// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "costs_" + chunkId + "." + {"1571":"1d6ff5bd861e63c5930a","1617":"17a81a349f4ce9049c14","2651":"972a9bb71de58b370e92","3352":"1d6ff5bd861e63c5930a","3996":"10721460106bd8a64b3e","4621":"1d6ff5bd861e63c5930a","6956":"1d030fca65bb663c3d5c"}[chunkId] + ".css";
};